import { GraphQLRequest } from 'apollo-link';
import { uapiConnection } from './uapiConnection';
import { UnifiedApplicationTreatmentEvent } from '../utils/applicationEventAdapter';

type UnifiedEventsResponse = {
  data?: {
    machineDataByFieldId?: {
      applicationEventAggregates?: {
        events?: UnifiedApplicationTreatmentEvent[] | null;
      } | null;
    } | null;
  } | null;
};

export const requestUnifiedApplicationEvents = async (
  request: GraphQLRequest,
): Promise<UnifiedApplicationTreatmentEvent[]> => {
  const response = (await uapiConnection(request)) as UnifiedEventsResponse;
  return response?.data?.machineDataByFieldId?.applicationEventAggregates?.events ?? [];
};
